import { gql } from '@apollo/client/core'

export const UNIT_ATTRIBUTES = gql`
  fragment unitAttributes on Unit {
    id
    name
  }
`
